<!--
  Horizontal rule between sections — the `sbi.ui.divider()` leaf.

  Renders a single `<hr>`. No props in v1; the wire op carries no fields
  beyond `op: "divider"`. CSS-only customisation through tokens.

  Embedder theming:
    - data-part="divider" — shadow-DOM-safe targeting hook.
    - --lucent-ui-divider-color  — rule colour (default: `var(--rule)`).
    - --lucent-ui-divider-spacing — vertical spacing top + bottom
      (default: `var(--space-4)`).
-->

<script setup lang="ts">
// Leaf component — no props, no emits, no children. Behaviour is
// entirely CSS-driven through the token contract above.
</script>

<template>
  <hr class="divider" data-part="divider" />
</template>

<style scoped>
.divider {
  border: 0;
  border-top: 1px solid var(--lucent-ui-divider-color, var(--rule));
  margin: var(--lucent-ui-divider-spacing, var(--space-4)) 0;
  height: 0;
}
</style>
